(function () {
    "use strict";

    angular.module("app").component("habilBranch", {
        template: `
        <div>
            {{ $ctrl.branch.Name }} ({{$ctrl.branch.BranchNbr}})
            <br>
            <habil-address address="$ctrl.branch"></habil-address>
        </div>
        `,
        bindings: { branch: "=" },
    });

})();